import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { getPaymentMethodTypeI18n } from '@woovi/shared';
import { AccountInfoLabel } from '@woovi/ui';

import type { PaymentLinkCompletedPaymentMethods_charge$key } from './__generated__/PaymentLinkCompletedPaymentMethods_charge.graphql.ts';
import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';

type PaymentLinkCompletedPaymentMethodsProps = {
  charge: PaymentLinkCompletedPaymentMethods_charge$key;
};
const PaymentLinkCompletedPaymentMethods = (
  props: PaymentLinkCompletedPaymentMethodsProps,
): ReactNode => {
  const { t } = useTranslation();
  const charge = useFragment<PaymentLinkCompletedPaymentMethods_charge$key>(
    graphql`
      fragment PaymentLinkCompletedPaymentMethods_charge on Charge {
        id
        ...useChargePaymentMethod_charge
      }
    `,
    props.charge,
  );

  const { paymentMethods } = useChargePaymentMethod(charge);

  const paymentMethodsI18n = paymentMethods.map((paymentMethod) => {
    if (!paymentMethod?.method) {
      return null;
    }

    return getPaymentMethodTypeI18n(paymentMethod.method, t);
  });

  if (!paymentMethodsI18n.length) {
    return null;
  }

  return (
    <AccountInfoLabel
      label={t('Payment Method')}
      text={paymentMethodsI18n.join(', ')}
    />
  );
};

export default PaymentLinkCompletedPaymentMethods;
